import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import DonutChart from "../../../../../src/components/DonutChart";
import * as React from 'react';
export default {
  Playground,
  Frame,
  DonutChart,
  React
};